import React from 'react';
import Col from 'react-bootstrap/Col';
import PropTypes from 'prop-types';
import Row from 'react-bootstrap/Row';
import ActionButton from './ActionButton';
import permissionsProvider from '../../../utilities/permissionsProvider';

const EditorSaveCancel = ({
    cancel,
    acl,
    save
}) => (
    <Row className="justify-content-center">
        <Col className="d-flex justify-content-center" >
            <ActionButton className="no-hide"
                buttonText="Save"
                imgSource="/images/check.svg"
                onClick={save}
                disabled={!permissionsProvider.canEdit(acl)}
            />
            <ActionButton className="no-hide"
                buttonText={!permissionsProvider.canEdit(acl) ? "Close" : "Cancel"}
                imgSource="/images/cancel.svg"
                onClick={cancel}
            />
        </Col>
    </Row>
);

EditorSaveCancel.propTypes = {
    cancel: PropTypes.func.isRequired,
    save: PropTypes.func.isRequired
}

export default EditorSaveCancel;